import React, {useContext} from 'react';
import "./QuestionAnswers.scss";
import { ConfigurationContext } from '../../Context/Configuration';

const QuestionAnswers = (props) => {
  const {question,questionNumber} = props;
  const [config, update] = useContext(ConfigurationContext);
  
  
 const selectAnswer = (answerNumber) => {
    let answer = question["answerOptions"][answerNumber];
    let questionsCopy = config.questions;
    questionsCopy[questionNumber]["selectedAnswer"] = answer;
    questionsCopy[questionNumber]["answerOptions"].map((elem,index)=>{
        if(index===answerNumber)
            elem["IsSelected"]=true;
        else
            elem["IsSelected"]=false;
    });
   
    update({...config, questions:questionsCopy})
 }
  
  
  return (
    <React.Fragment>
        
    <p className="questionText">{question["questionText"]}</p>
    <div className="options">
        {
            question["questionImage"] === "" ? "":    
            <div className="img_container">
                <img alt='question' src={question["questionImage"]}/>
            </div>
        }
     
        
     <div>
            <div>
               <label htmlFor="option1"> <input disabled={config.disableOptions} id="option1" checked={question["answerOptions"][0]["IsSelected"]}  onClick={()=>selectAnswer(0)} type="radio" value={question["answerOptions"][0]["answerText"]} name="group1"/> {question["answerOptions"][0]["answerText"]}</label>
            </div>
            <div>
              
                <label htmlFor="option2"> <input disabled={config.disableOptions} id="option2" checked={question["answerOptions"][1]["IsSelected"]}  onClick={()=>selectAnswer(1)} type="radio" value={question["answerOptions"][1]["answerText"]} name="group1"/>  {question["answerOptions"][1]["answerText"]}</label>
            </div>
        </div>
        <div>
            <div>
                <label htmlFor="option3"> <input disabled={config.disableOptions} id="option3" checked={question["answerOptions"][2]["IsSelected"]} onClick={()=>selectAnswer(2)} type="radio" value={question["answerOptions"][2]["answerText"]} name="group1"/>  {question["answerOptions"][2]["answerText"]}</label> 
            </div>
            <div>
                <label htmlFor="option4"> <input disabled={config.disableOptions} id="option4" checked={question["answerOptions"][3]["IsSelected"]} onClick={()=>selectAnswer(3)} type="radio" value={question["answerOptions"][3]["answerText"]} name="group1"/>  {question["answerOptions"][3]["answerText"]}</label>
           </div>
        </div>
    </div>
        
    </React.Fragment>
   
  );
};

export default QuestionAnswers;